import React, { useContext } from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
const OwnerProfileShopPlacement = ()=>{
    const { isLoggedIn } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    if (isMobile) {
        return null;
    }
    // User
    if (isLoggedIn) {
        return /*#__PURE__*/ React.createElement(BannerAdUnit, {
            width: "900px",
            height: "64px",
            realEstateId: "585c7db2-5d1d-4bfc-86ab-5f096ae1c49f"
        });
    }
    return null;
};
OwnerProfileShopPlacement.displayName = 'OwnerProfileShopPlacement';
export default OwnerProfileShopPlacement;
